var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"context_menu_container",style:({
    top: `${_vm.topPosition}px`,
    left: `${_vm.leftPosition}px`,
  }),attrs:{"id":"context_menu"}},_vm._l((_vm.data),function(item){return (item.condition)?_c('div',{key:item.id,staticClass:"menu_item",attrs:{"id":item.id},on:{"click":function($event){$event.stopPropagation();item.handler(..._vm.handlerArgs)
      _vm.onClickHandler()}}},[_c('font-awesome-icon',{class:item.iconClasses,attrs:{"title":item.label,"icon":item.iconType}}),_c('span',{style:({marginLeft: _vm.isDeleteField(item) ? '1px' : 0})},[_vm._v(" "+_vm._s(item.label)+" ")])],1):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }